<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="RkmModal"
        title="Condição de saúde do paciente"
    >
        <BoxAlergia :data="data" />
        <BoxMedicamentoUsoContinuo :data="data" />
        <BoxMedicamentoUso :data="data" />
        <BoxSinalVital :data="data" />
        <BoxAnotacaoEnfermagem :data="data" />
    </rkm-modal>
</template>

<script>
// Components.
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxAnotacaoEnfermagem from '@/components/pronto-atendimento/components/anotacao-enfermagem/Index'
import BoxMedicamentoUso from '@/components/pronto-atendimento/components/medicamento-uso/Index'
import BoxMedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import BoxSinalVital from '@/components/pronto-atendimento/components/sinal-vital/Index'

export default {
    components: {
        BoxAlergia,
        BoxAnotacaoEnfermagem,
        BoxMedicamentoUso,
        BoxMedicamentoUsoContinuo,
        BoxSinalVital,
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        }
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
